import { render, staticRenderFns } from "./ActivitiesTimelineItem.vue?vue&type=template&id=54b3f833&"
import script from "./ActivitiesTimelineItem.vue?vue&type=script&lang=js&"
export * from "./ActivitiesTimelineItem.vue?vue&type=script&lang=js&"
import style0 from "./ActivitiesTimelineItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports